import logo from './logo.svg';
import './App.css';

function App() {

  const handleSubmit = async(e) => {
    // Prevent the browser from reloading the page
    e.preventDefault();

    // Read the form data
    const form = e.target;
    const formData = new FormData(form);
    const formJson = Object.fromEntries(formData.entries());

    const message = {
      "message": formJson.message,
      "beep": false
    };

    // You can pass formData as a fetch body directly:
    const response = await fetch('https://estudio.igrejafontedarenovacao.com.br/api/send',
      {
        mode: 'cors',
        method: 'POST',
        body: JSON.stringify(message),
        headers:
          { 'Content-Type': 'application/json'}
      })
      
    console.log(response);

    form.reset();
  }

  return (
    <div className="App">
      <div className="Wrapper">
        <form method="post" onSubmit={handleSubmit}>
          <div name="MessageArea">
            <textarea name="message" rows={5} cols={40} autofocus />
          </div>
          <div name="Buttons">
            <button type="reset">Limpar</button>
            <button type="submit">Enviar</button> 
          </div>
      </form>
      </div>
    </div>
  );
}

export default App;
